/* KahveYanımda — uygulama tarzı arayüz katmanı (sepet çubuğu, adet rozetleri, yapışkan başlık, menü arama) */
(function () {
  'use strict';
  var root = document.documentElement;

  /* ---- Sepet: her biGetCart çağrısında arayüzü güncelle ---- */
  function renderCart(cart) {
    if (!cart) return;
    var count = Number(cart.item_count || 0);
    var bar = document.querySelector('[data-ky-cartbar]');
    if (bar) {
      bar.hidden = count === 0;
      var c = bar.querySelector('[data-ky-cartbar-count]');
      var t = bar.querySelector('[data-ky-cartbar-total]');
      var v = bar.querySelector('[data-ky-cartbar-vendor]');
      if (c) c.textContent = count;
      if (t && typeof window.biMoney === 'function') t.textContent = window.biMoney(cart.total_price);
      if (v) v.textContent = (cart.items && cart.items[0] && cart.items[0].vendor) || '';
      bar.setAttribute('aria-label', 'Sepeti görüntüle, ' + count + ' ürün');
      if (count > 0) { bar.classList.remove('is-bump'); void bar.offsetWidth; bar.classList.add('is-bump'); }
    }
    document.body.classList.toggle('has-cartbar', !!bar && count > 0);
    var qty = {};
    (cart.items || []).forEach(function (i) { qty[i.variant_id] = (qty[i.variant_id] || 0) + Number(i.quantity || 0); });
    document.querySelectorAll('.kyc[data-variant-id]').forEach(function (card) {
      var n = qty[card.dataset.variantId] || 0;
      var badge = card.querySelector('[data-kyc-qty]');
      card.classList.toggle('in-cart', n > 0);
      if (badge) { badge.hidden = n === 0; badge.textContent = n; badge.setAttribute('aria-label', 'Sepette ' + n + ' adet'); }
    });
  }

  if (typeof window.biGetCart === 'function') {
    var original = window.biGetCart;
    window.biGetCart = async function () {
      var cart = await original.apply(this, arguments);
      try { renderCart(cart); } catch (_) {}
      return cart;
    };
  }

  /* ---- Yapışkan başlık: kaydırınca kompakt ---- */
  var header = document.querySelector('[data-ky-header]');
  if (header) {
    var search = header.querySelector('.bi-search');
    var ticking = false, compact = false;
    var measure = function () {
      if (compact) return;
      root.style.setProperty('--ky-hd-h', header.offsetHeight + 'px');
      if (search) root.style.setProperty('--ky-row1', Math.max(0, search.offsetTop - 8) + 'px');
      setVisible();
    };
    var setVisible = function () {
      root.style.setProperty('--ky-hd-vis', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
    };
    var onScroll = function () {
      ticking = false;
      var y = window.scrollY || 0;
      var next = compact ? y > 30 : y > 90;
      if (next !== compact) { compact = next; header.classList.toggle('is-compact', compact); if (!compact) measure(); }
      setVisible();
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    header.addEventListener('transitionend', setVisible);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    window.addEventListener('resize', measure);
    measure(); onScroll();
  }

  /* ---- Kategori çipleri: aktif olanı işaretle ve görünür yap ---- */
  var chips = document.querySelector('[data-ky-chips]');
  if (chips) {
    var path = location.pathname.replace(/\/$/, '');
    chips.querySelectorAll('a').forEach(function (a) {
      var p = new URL(a.href, location.origin).pathname.replace(/\/$/, '');
      if (a.getAttribute('href').charAt(0) !== '#' && p && p === path) {
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'page');
        var box = a.parentElement;
        if (box) box.scrollLeft = a.offsetLeft - box.clientWidth / 2 + a.offsetWidth / 2;
      }
    });
  }

  /* ---- Menüde ara (koleksiyon sayfası) ---- */
  var filter = document.querySelector('[data-kym-filter]');
  var grid = document.querySelector('[data-kym-grid]');
  if (filter && grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.kyc'));
    var empty = document.querySelector('[data-kym-empty]');
    var norm = function (s) { return (s || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ı/g, 'i'); };
    var index = cards.map(function (c) { return norm(c.dataset.kycSearch || c.textContent); });
    filter.addEventListener('input', function () {
      var q = norm(filter.value.trim());
      var shown = 0;
      cards.forEach(function (c, i) { var ok = !q || index[i].indexOf(q) > -1; c.hidden = !ok; if (ok) shown++; });
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* ---- Karttaki "+" butonu: kısa geri bildirim ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.kyc-add');
    if (!add) return;
    add.classList.remove('is-pop'); void add.offsetWidth; add.classList.add('is-pop');
  });
})();

/* ---- Çerez onayı (Shopify Customer Privacy API ile) ---- */
(function () {
  var bar = document.querySelector('[data-ky-consent]');
  var modal = document.querySelector('[data-ky-consent-modal]');
  if (!bar && !modal) return;
  var KEY = 'kyConsent', MAX_AGE = 365 * 864e5, lastFocus = null;
  function read() { try { var c = JSON.parse(localStorage.getItem(KEY)); if (c && Date.now() - c.t < MAX_AGE) return c; } catch (_) {} return null; }
  function apply(c) {
    var send = function () { try { window.Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing }, function () {}); } catch (_) {} };
    if (window.Shopify && window.Shopify.customerPrivacy) send();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) send(); });
  }
  function close() { if (modal && !modal.hidden) { modal.hidden = true; document.body.classList.remove('panel-open'); if (lastFocus) lastFocus.focus(); } }
  function open() {
    if (!modal) return;
    lastFocus = document.activeElement;
    var c = read() || {};
    modal.querySelectorAll('[data-ky-consent-key]').forEach(function (i) { i.checked = !!c[i.dataset.kyConsentKey]; });
    modal.hidden = false; document.body.classList.add('panel-open');
    var x = modal.querySelector('.kyck-x'); if (x) x.focus();
  }
  function save(c) {
    c.t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (_) {}
    apply(c); if (bar) bar.hidden = true; close();
    document.dispatchEvent(new CustomEvent('ky:consent', { detail: c }));
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ky-consent-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-ky-consent-close]')) { close(); return; }
    if (e.target.closest('[data-ky-consent-accept]')) { save({ preferences: 1, analytics: 1, marketing: 1 }); return; }
    if (e.target.closest('[data-ky-consent-reject]')) { save({ preferences: 0, analytics: 0, marketing: 0 }); return; }
    if (e.target.closest('[data-ky-consent-save]')) { var c = {}; modal.querySelectorAll('[data-ky-consent-key]').forEach(function (i) { c[i.dataset.kyConsentKey] = i.checked ? 1 : 0; }); save(c); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  var saved = read();
  if (saved) apply(saved); else if (bar) bar.hidden = false;
})();

/* ---- Boş kalan bölümleri gizle (ör. aramada eşleşen işletme yoksa) ---- */
document.querySelectorAll('[data-ky-hide-empty]').forEach(function (s) {
  if (!s.querySelector(s.getAttribute('data-ky-hide-empty'))) s.hidden = true;
});
